import React, { useState, useEffect, useRef } from "react";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";
import { Link, useLocation } from "react-router-dom";
import paginationValue from "../common/paginationValue.json";
import Pagination from "../components/Layout/Pagination";
import aldotImg from "../assets/WAH-Logo-ALDOT-Approved.png";
import MRBLOGO from "../assets/KMT_Logo_WhiteBG.png";

import AxiosInstance from "../utils/axiosInstance";
import axios from "axios";
import toast from "react-hot-toast";
import loader from "../assets/loader.svg";

function MeetingAndAttandancePage() {
  const [activeTab, setActiveTab] = useState(0);
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(paginationValue.currentPage);
  const [pageLimit, setPageLimit] = useState(paginationValue.limit);
  const [totalPages, setTotalPages] = useState(1);
  const [categoryObject, setCategoryObject] = useState(
    location.state?.category || { label: "Meetings", value: "meeting" ,page : "WAH"}
  );


  const [userType, setUserType] = useState();

  const [showloader, setLoader] = useState(false);
  const [uploadData, setUploadData] = useState({
    name: "",
    type: categoryObject.value,
    file: null,
    page :categoryObject.page
  });
  const [List, setList] = useState([]);

  const [errors, setErrors] = useState({});
  const isFileCorruptedRef = useRef(false);
  const [showLoader, setShowLoader] = useState(false);
  const [APICall, setAPICAll] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);

  const abortControllerRef = useRef(null);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("loggedInUserInfo") || "[]");
    const userType = data?.user_type; // Get user_type from localStorage data
    setUserType(userType); // Set the userType

     setCategoryObject(
      location.state?.category || { label: "Meetings", value: "meeting" ,page : userType === "MRB" ? "MRB" : "WAH"}
    );
    getList();
  }, []);

  useEffect(() => {
    if (currentPage > 0) {
      getList();
    }
  }, [currentPage]);

  const getList = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    setAPICAll(false);
    const queryParams = new URLSearchParams({
      doc_type: categoryObject.value,
      page: currentPage,
      limit: pageLimit,
      user_type : categoryObject.page,
      // state_id: selectedState?.value,
    });

    setLoader(true);
    const controller = new AbortController();
    abortControllerRef.current = controller;

    const currentTime = new Date().getTime();
    AxiosInstance.get(
      `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_GET_MEETING_AND_ATTANDANCE_FILE}?currentTime=${currentTime}&${queryParams}`,
      { signal: controller.signal }
    )
      .then((response) => {
        if (response.data?.data) {
          setList(response.data?.data);
          setPageLimit(response.data?.limit);
          setTotalRecords(response.data?.total_records);
          setTotalPages(response.data?.total_pages);
          setCurrentPage(response.data?.page);
          setLoader(false);
          toast.success(
            "successfully fetching data ..." || response.data?.message
          );
        } else {
          setList([]);
          setLoader(false);
          toast.success(response.data?.message);
        }
      })
      .catch((error) => {
        console.error("error", error);
        if (axios.isCancel(error) || error.code === "ERR_CANCELED") {
          // console.log("Aborted");
          //toast.error(error?.message);
        } else {
          toast.error(
            error?.data?.message || error?.message || "Something went wrong"
          );
          setLoader(false);
        }
      });
  };

  return (
    <>
      <Header />
      <div className={`bg-primary pt-5 ${activeTab !== 1 ? "pb-20" : ""}`}>
        <div className="container">
          <div className="row">
            <div className="col col-md-auto bg-primary mb-3">
              <h1 className="text-secondary fw-boldest point-42">
                {activeTab === 0
                  ? categoryObject.label.toUpperCase()
                  : "Uploading Request"}
              </h1>
              <div className="dotPage"></div>
            </div>

            { (
              <>
                <div
                  className="dotPage col align-self-end mb-3 text-center"
                  style={{ marginLeft: "20%" }}
                >
                  <ul className="nav nav-tabs align-items-center justify-content-end">
                    <li className="nav-item">
                      <Link
                        to="/directory"
                        className="nav-link fw-bolder text-uppercase point-16 text-secondary"
                        title="Directory"
                      >
                        DBE Directory
                      </Link>
                    </li>
                    <span className="point-16 fw-bolder text-danger mx-2">
                      |
                    </span>
                    <li className="nav-item">
                      <a
                        href={
                          categoryObject.page === "MRB"
                            ? "https://mobileriverbridge.com/"
                            : "https://westalabamahighway.com/"
                        }
                        className="nav-link fw-bolder text-uppercase point-16 text-secondary"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        B&G
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col col-md-2 text-end">
                  <a
                    href={
                      categoryObject.page === "MRB"
                        ? "https://mobileriverbridge.com/"
                        : "https://westalabamahighway.com/"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={categoryObject.page === "MRB" ? MRBLOGO : aldotImg}
                      width="160px"
                      alt={categoryObject.value}
                      style={{ cursor: "pointer" }}
                    />
                  </a>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {activeTab === 0 && (
        <div className="bg-white py-3">
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="card w-100 mt-n20 bg-white rounded-3 shadow-sm mb-5">
                  <div className="card-body p-3">
                    {showloader ? (
                      <div className="loader">
                        <img src={loader} alt="loading" />
                      </div>
                    ) : (
                      <ul className="list-group py-3">
                        {
                          categoryObject &&
                          categoryObject.value === "meeting" ? (
                            List && List.length > 0 ? (
                              List.map((data, i) => (
                                <li
                                  key={i}
                                  className="list-group-item slideup-p py-3 mb-3 bg-light border border-1 rounded-0"
                                >
                                  <div className="d-md-flex justify-content-between align-items-start">
                                    <div className="me-auto mb-2">
                                      <span className="fw-bold point-22">
                                        {data.name}
                                      </span>
                                    </div>
                                    <div className="mb-2">
                                      <a
                                        className="badge bg-secondary text-decoration-none text-primary rounded-pill text-uppercase py-1 px-3 fw-semibold point-16"
                                        href={data.doc_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        View
                                      </a>
                                    </div>
                                  </div>
                                </li>
                              ))
                            ) : (
                              <li className="list-group-item py-3 text-center text-muted">
                                No meeting records available.
                              </li>
                            )
                          ) : List && List.length > 0 ? (
                            List.map((data, i) => (
                              <li
                                key={i}
                                className="list-group-item slideup-p py-3 mb-3 bg-light border border-1 rounded-0"
                              >
                                <div className="d-md-flex justify-content-between align-items-start">
                                  <div className="me-auto mb-2">
                                    <span className="fw-bold point-22">
                                      {data.name}
                                    </span>
                                  </div>
                                  <div className="mb-2">
                                    <a
                                      className="badge bg-secondary text-decoration-none text-primary rounded-pill text-uppercase py-1 px-3 fw-semibold point-16"
                                      href={data.doc_url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View
                                    </a>
                                  </div>
                                </div>
                              </li>
                            ))
                          ) : (
                            <li className="list-group-item py-3 text-center text-muted">
                              No {categoryObject.label} records available.
                            </li>
                          )
                          // <li className="list-group-item slideup-p py-3 mb-3 bg-light border border-1 rounded-0">
                          //   <div className="d-md-flex justify-content-between align-items-start">
                          //     <div className="me-auto mb-2">
                          //       <span className="fw-bold point-22">
                          //         Demopolis Outreach
                          //       </span>
                          //     </div>
                          //     <div className="mb-2">
                          //       <a
                          //         className="badge bg-secondary text-decoration-none text-primary rounded-pill text-uppercase py-1 px-3 fw-semibold point-16"
                          //         href="https://dev.contractorcn.com/resources_file/Registration_Report_ALDOT_West_Alabama_Highway.pdf"
                          //         target="_blank"
                          //         rel="noopener noreferrer"
                          //       >
                          //         View
                          //       </a>
                          //     </div>
                          //   </div>
                          // </li>
                        }
                      </ul>
                    )}

                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      pageLimit={pageLimit}
                      onPageChange={handlePageChange}
                    />

                    {/* {showModal && (
                     
                    )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

export default MeetingAndAttandancePage;
